import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const termsCss: CSSObject = {
  ...typographyStyles.textMObj,
  color: constants.colors.ui.neutral[600],
  justifySelf: "center",
  "& a": {
    color: constants.colors.ui.core[700],
    padding: 0,
  },
};
